<template>
	<div>
    <div style="width:104%;background-color: #f8fafe;height: 10px;margin-left: -2%;"></div>
		<h3>机构信息设置 <small class="yellow">机构ID：{{channelId}}</small></h3>
		<div class="block">
			<el-form :model="formLabelAlign" label-width="100px">
				<el-form-item label="机构名称">
					<el-input v-model="formLabelAlign.name" disabled></el-input>
				</el-form-item>
				<el-form-item label="机构地址">
					<el-input v-model="formLabelAlign.contact2"></el-input>
				</el-form-item>
				<el-form-item label="机构电话">
					<el-input v-model="formLabelAlign.contact1"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<h3>机构银行账户信息 </h3>
		<div class="block">		
			<el-form :model="formLabelAlign" label-width="100px">	
        <el-form-item label="账户类型">
					<span class="tab"  :class="{active:activeIndex == 0}" @click="activeIndex = 0">个人</span>
          <span class="tab"  :class="{active:activeIndex == 1}" @click="activeIndex = 1" style="margin-left:15px">机构</span>
				</el-form-item>
				<el-form-item label="开户名">
					<el-input v-model="formLabelAlign.accountName"></el-input>
				</el-form-item>
				<el-form-item label="开户行名称">
					<el-input v-model="formLabelAlign.bankName"></el-input>
				</el-form-item>
				<el-form-item label="银行卡号">
					<el-input v-model="formLabelAlign.accountNo"></el-input>
				</el-form-item>
			</el-form>
		</div>
    <h3>开户人证件信息 </h3>
		<div class="remark-text" style="color: red; margin-bottom: 20px; line-height: 1.8;">
			<div>为保障资金安全，提现需验证身份：</div>
			<div>个人：提供身份证正反面 + 手持照</div>
			<div>机构：提供营业执照</div>
			<div>信息仅用于验证，严格保密。感谢支持！</div>
		</div>
		<div class="block" style="width:100%">	
          <el-row style="margin-bottom: 70px;">
            <el-col style="width: 280px;height: 210px;background-color: #f3f4f6;" :span="6">
                 <div style="text-align: center;">
                    <div style="margin-bottom:15px;margin-top:26px">证件一</div>
                    <img style="width: 200px;height: 120px;margin: 0 auto;" v-if="imageUrl" :src="imageUrl" @click.self="showBigImage($event)" class="avatar">
                    <img style="width: 200px;height: 120px;margin: 0 auto;" v-else src="./img/OriginalIDcard.png" class="avatar">
                  <el-upload
                    class="avatar-uploader"
                    action="aaa"
                    :show-file-list="false"
                      :on-exceed="handleExceed"
                    :file-list="fileList"
                    :before-upload="beforeAvatarUpload"
                    :http-request="requestFile"
                    >
                         <el-button style="margin-top:46px;width: 117px;height: 28px;" size="small" type="primary">点击上传</el-button>
                  </el-upload>
                 </div>
            </el-col>
            <el-col style="width: 280px;height: 210px;background-color: #f3f4f6;margin-left: 20px;" :span="6">
               <div style="text-align: center;">
                       <div style="margin-bottom:15px;margin-top:26px">证件二</div>
                       <img style="width: 200px;height: 120px;margin: 0 auto;" v-if="imageUrl1" :src="imageUrl1" @click.self="showBigImage($event)" class="avatar" >
                     <img style="width: 200px;height: 120px;margin: 0 auto;" v-else src="./img/OriginalIDcard.png" class="avatar">
                  <el-upload
                    class="avatar-uploader"
                    action="aaa"
                    :show-file-list="false"
                      :on-exceed="handleExceed1"
                    :file-list="fileList1"
                    :before-upload="beforeAvatarUpload1"
                    :http-request="requestFile1">
                      <el-button style="margin-top:46px;width: 117px;height: 28px;" size="small" type="primary">点击上传</el-button>
                    <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                  </el-upload>
               </div>
            </el-col>
                <el-col style="width: 280px;height: 210px;background-color: #f3f4f6;margin-left: 20px;" :span="6">
               <div style="text-align: center;">
                    <div style="margin-bottom:15px;margin-top:26px">证件三</div>
                    <img style="width: 200px;height: 120px;margin: 0 auto;" v-if="imageUrl3" @click.self="showBigImage($event)"  :src="imageUrl3" class="avatar">
                   <img style="width: 200px;height: 120px;margin: 0 auto;" v-else src="./img/OriginalIDcard.png" class="avatar">
                <el-upload
                  class="avatar-uploader"
                  action="aaa"
                  :show-file-list="false"
                  :on-exceed="handleExceed3"
                  :file-list="fileList3"
                  :before-upload="beforeAvatarUpload3"
                  :http-request="requestFile3">
                  <el-button style="margin-top:46px;width: 117px;height: 28px;" size="small" type="primary">点击上传</el-button>
                </el-upload>
                </div>
            </el-col>
          </el-row>
    </div>
     <div style="width:104%;background-color: #f8fafe;height: 10px;margin-left: -2%;"></div>
		<el-button class='btn' type="primary" @click='setData(true)'>
      <span v-if="aaa == true">提交信息</span>
      <span v-else>修改信息</span>
    </el-button>
    <BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}"></BigImg>
	</div>
</template>

<script>
	import { setInfo,getInfo } from '@/axios/api.js'
   import axios from 'axios'
   import BigImg from "./BigImg.vue";
	export default {
		data() {
			return {
				photoVisible: false,
				bigImgUrl: "",
				aaa:true,
				activeIndex:0,
				imageUrl:'',
				imageUrl1:'',
				imageUrl3:'',
				fileList: [],
				fileList1:[],
				fileList3:[],
				formLabelAlign: {
					name: '',
					contact1: '',
					contact2: '',
					accountName:'',
					bankName:'',
					accountNo:''
				},
				channelId:JSON.parse(window.localStorage.getItem("token")).data.obj2.channelId
			};
		},
		components: {
			BigImg,
		},
		methods:{
         showBigImage(e) {//点击图片函数，点击后，把photoVisible设置成true
			if (e != "") {
			this.photoVisible = true;
			this.bigImgUrl = e.currentTarget.src;
			}
		},
      	handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log(file);
		},
		handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${ file.name }？`);
		},
		beforeAvatarUpload(file) {
			console.log(file);
			var reg = /(.*)\.(jpg|gif|bmp|png)$/
			if(!reg.test(file.name)){
			this.$message.error('上传仅支持jpg、gif、bmp、png格式');
			return false;
			}
			const isLt8M = file.size / 1024 / 1024 < 5;
			if (!isLt8M) {
				this.$message.error('上传头像图片大小不能超过 5MB!');
			}
			return isLt8M;
		},
      requestFile(param) {
      	var fileObj = param.file
      	let config = {
      		headers: {
      			"Content-Type": "multipart/form-data"
      		}
      	};
      	var form = new FormData() // FormData 对象
      	var token = JSON.parse(window.localStorage.getItem("token")).data.obj.token
      	form.append('file', fileObj) // 文件对象
      	form.append('token', token) // 文件对象
      	axios.post(API_BASE + 'rescue_sale/sale/upload', form, config)
      		.then(res => {
      			if (res.data.code == 0) {
                this.imageUrl = res.data.obj
      			}
      		})
      		.catch(err => {
      			console.log(err)
      		})
      },

      handleExceed1(files, fileList) {
		this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
	  },
      beforeRemove1(file, fileList) {
		return this.$confirm(`确定移除 ${ file.name }？`);
	  },
	  beforeAvatarUpload1(file) {
		var reg = /(.*)\.(jpg|gif|bmp|png)$/
		if(!reg.test(file.name)){
		this.$message.error('上传仅支持jpg、gif、bmp、png格式');
		return false;
		}
		const isLt8M = file.size / 1024 / 1024 < 5;
		if (!isLt8M) {
			this.$message.error('上传头像图片大小不能超过 5MB!');
		}
		return isLt8M;
	  },
      requestFile1(param) {
      	var fileObj = param.file
      	let config = {
      		headers: {
      			"Content-Type": "multipart/form-data"
      		}
      	};
      	var form = new FormData() // FormData 对象
      	var token = JSON.parse(window.localStorage.getItem("token")).data.obj.token
      	form.append('file', fileObj) // 文件对象
      	form.append('token', token) // 文件对象
      	axios.post(API_BASE + 'rescue_sale/sale/upload', form, config)
      		.then(res => {
      			if (res.data.code == 0) {
              this.imageUrl1 = res.data.obj
      			}
      		})
      		.catch(err => {
      			console.log(err)
      		})
      },

      handleExceed3(files, fileList) {
		   this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
	  },
	 beforeRemove3(file, fileList) {
	      return this.$confirm(`确定移除 ${ file.name }？`);
	 },
	beforeAvatarUpload3(file) {
		console.log(file);
		var reg = /(.*)\.(jpg|gif|bmp|png)$/
		if(!reg.test(file.name)){
		this.$message.error('上传仅支持jpg、gif、bmp、png格式');
		return false;
		}
		const isLt8M = file.size / 1024 / 1024 < 5;
		if (!isLt8M) {
			this.$message.error('上传头像图片大小不能超过 5MB!');
		}
		return isLt8M;
	},
	requestFile3(param) {
		var fileObj = param.file
		let config = {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		};
		var form = new FormData() // FormData 对象
		var token = JSON.parse(window.localStorage.getItem("token")).data.obj.token
		form.append('file', fileObj) // 文件对象
		form.append('token', token) // 文件对象
		axios.post(API_BASE + 'rescue_sale/sale/upload', form, config)
		.then(res => {
			if (res.data.code == 0) {
			this.imageUrl3 = res.data.obj
			}
		})
		.catch(err => {
			console.log(err)
		})
	},

	setData(status){
		if(this.activeIndex == 0) {
			if(this.imageUrl == '' || this.imageUrl == null || this.imageUrl == undefined) {
			this.$message.error('开户人证件信息必填');
			return
			}
		}
		var data={
			contact1:this.formLabelAlign.contact1,
			contact2:this.formLabelAlign.contact2,
			accountName:this.formLabelAlign.accountName,
			bankName:this.formLabelAlign.bankName,
			accountNo:this.formLabelAlign.accountNo,
		}
		if(this.imageUrl != '' && this.imageUrl != null &&  this.imageUrl != undefined) {
			this.formLabelAlign.nationalFront = this.imageUrl
		}
		if(this.imageUrl1 != ''&& this.imageUrl1 != null &&  this.imageUrl1 != undefined) {
			this.formLabelAlign.nationalBack = this.imageUrl1
		}
			if(this.imageUrl3 != ''&& this.imageUrl3 != null &&  this.imageUrl3 != undefined) {
			this.formLabelAlign.nationalValid = this.imageUrl3
		}
		setInfo(this.formLabelAlign)
		.then(res => {
			if(res.data.code == 0){
				this.formLabelAlign=res.data.obj;
				this.$message({
					showClose: true,
					message: '恭喜你，修改成功！',
					type: 'success'
				});						
			}else{
				this.$message(res.deta.msg);
			}
		})
		.catch( err => {
			console.log(err)
		})
	},
	getData(status){
		getInfo()
		.then(res => {
		localStorage.setItem("category", res.data.obj.category);
			if(res.data.code == 0){
				this.formLabelAlign=res.data.obj;
				this.imageUrl = res.data.obj.nationalFront
				this.imageUrl1 = res.data.obj.nationalBack
				this.imageUrl3 = res.data.obj.nationalValid
				if(this.formLabelAlign.accountName == null || this.formLabelAlign.bankName == null ||  this.formLabelAlign.accountNo == null || this.imageUrl == null || this.imageUrl1 == null || this.imageUrl3 == null) {
					this.aaa = true
				}else {
					this.aaa = false
				}
			}else{
				this.$message.warning(res.data.msg);
			}
		})
		.catch( err => {
			console.log(err)
		})
	},
		},
		mounted() {
         this.getData()
      }
  }
</script>

<style scoped="scoped">
.active {
  background-color: #409EFF;
  color: #ffffff;
}
.tab {
  display: inline-block;
  width: 100px;
  height: 40px;
  text-align: center;
    /* padding: 10px 20px; */
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    cursor:pointer
}
	h3 {
		margin: 20px 0;
		font-weight: normal;
	}
	.block{width: 600px;overflow: hidden;}
	.btn{width: 320px;margin-top: 24px;margin-bottom: 150px;}
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px solid;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/index.vue